import { memo } from 'react';
import { GridProps } from '@mui/material';
import { CreditCardProviderEnum } from '../../enums';
import {
  SmallCreditCardIcon,
  AmexIcon,
  DiscoverIcon,
  MastercardIcon,
  VisaIcon,
} from '../../icons';
import { mergeSX } from '../../services/helpers';
import Grid from '../Grid';

export interface ICreditCardAvatarProps extends GridProps {
  width?: number | string;
  height?: number | string;
  type: string | null;
  outlineColor?: string;
}

interface IBuildSXParams {
  outlineColor?: string;
}

const CREDIT_CARD_ICONS = {
  [CreditCardProviderEnum.AmericanExpress]: AmexIcon,
  [CreditCardProviderEnum.Discover]: DiscoverIcon,
  [CreditCardProviderEnum.Mastercard]: MastercardIcon,
  [CreditCardProviderEnum.Visa]: VisaIcon,
};

const buildSX = ({ outlineColor }: IBuildSXParams) => (
  { boxShadow: outlineColor && `0 0 0 2px ${outlineColor}` }
);

const CreditCardAvatar = (props: ICreditCardAvatarProps) => {
  const {
    sx, width = 60, height = 40, marginRight = 1, type, outlineColor, ...rest
  } = props;

  const IconComponent = CREDIT_CARD_ICONS[type as keyof typeof CREDIT_CARD_ICONS];

  if (!IconComponent) {
    return (
      <Grid
        width={width}
        height={height}
        borderRadius={1}
        marginRight={marginRight}
        sx={mergeSX(buildSX({ outlineColor }), sx)}
        {...rest}
      >
        <SmallCreditCardIcon width={width} height={height} />
      </Grid>
    );
  }

  return (
    <Grid
      width={width}
      height={height}
      borderRadius={1}
      marginRight={marginRight}
      sx={mergeSX(buildSX({ outlineColor }), sx)}
      {...rest}
    >
      <IconComponent width={width} height={height} />
    </Grid>
  );
};

export default memo(CreditCardAvatar);
